<template>
  <div class="home">
    <VideoListPlugin class="marginal"></VideoListPlugin>
  </div>
</template>

<script>
import VideoListPlugin from "@/components/VideoListPlugin.vue";

export default {
  name: "videolistplugin",
  components: {
    VideoListPlugin,
  },
};
</script>
